import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import MerchantLogo from "./MerchantLogo";
import MerchantLogo1xbet from "./MerchantLogo1xbet";

function MerchantLogoIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? (
    <MerchantLogo1xbet {...props} />
  ) : (
    <MerchantLogo {...props} />
  );
}

export default MerchantLogoIndex;
